<template>
  <div>
    <el-collapse-transition>
      <div
        v-show="item.visible"
        class="question-list-item" style="
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;padding-left: 40px;">
        <div class="fisrt-point-box" @click="changeVisible">
          <span
            :class="{'is-rotate': ownVisible}"
            class="first-point-icon-question">
            <img src="@/assets/img/comet/quiz/shi@2x.png" alt="">
          </span>
          {{item.text}}
          <span class="primary-badge" v-if="item.question_count[0] === 0">no questions uploaded</span>
          <span class="primary-badge" v-else>{{ item.question_count[1] + ' / ' + item.question_count[0] }}</span>
          <!-- <span class="new-badge" v-if="item.question_count[2] !== 0">NEW {{ item.question_count[2] }}</span> -->
          <span class="bg-bottom-line"></span>
        </div>
        <el-collapse-transition>
          <ul
            v-show="ownVisible"
            v-if="item.nodes"
            ref="ulBox">
              <li
                class="second-point-item"
                v-for="child in item.nodes"
                @click="goQuiz(child)"
                :key="child.id">
                <ct-icon class="sandwichIcon" style="margin-right: 16px;" name="sandwich"></ct-icon>
                {{ child.text }}
                <template v-if="knowledgeCount && knowledgeCount[child.id]">
                  <span class="primary-badge" v-if="!knowledgeCount[child.id][0]">0</span>
                  <span class="primary-badge" v-else>{{ knowledgeCount[child.id][1] + ' / ' + knowledgeCount[child.id][0] }}</span>
                  <span class="new-badge" v-if="knowledgeCount[child.id][2] !== 0">NEW {{ knowledgeCount[child.id][2] }}</span>
                </template>
                <template v-else>
                  <span class="primary-badge" >0</span>
                </template>
              </li>
          </ul>
        </el-collapse-transition>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import api from '../../api'
export default {
  name: 'QuizItem',
  props: {
    item: Object,
    ownVisible: Boolean,
    visChangeDown: Boolean
  },
  data () {
    return {
      knowledgeCount: undefined,
      firstDown: false
    }
  },
  methods: {
    changeVisible () {
      if (!this.visChangeDown) return
      if (!this.item.nodes || !this.item.nodes.length) return
      if ((!this.firstDown) && (!this.ownVisible)) {
        api.getQuestionsCount({
          params: {
            parent_id: this.item.id
          }
        }).then(res => {
          let data = res.data
          this.firstDown = true
          if (data.code === 1) {
            data = data.data
            let b = {}
            Object.keys(data.questions_count).forEach(el => {
              let a = JSON.parse(JSON.stringify(data.questions_count[el]))
              a.shift()
              b[data.questions_count[el][0]] = a
            })
            this.knowledgeCount = b
          }
          this.$emit('changeVis', this.item)
        })
        return
      }
      this.$emit('changeVis', this.item)
    },
    goQuiz (point) {
      if (this.knowledgeCount[point.id]) {
        this.$emit('clickSecond', point)
      }
    }
  },
  computed: {
  },
  mounted () {
  }
}
</script>

<style lang="scss">
  .question-list-item {
    .fisrt-point-box {
      position: relative;
      height: 46px;
      line-height: 46px;
      font-size:14px;
      font-weight:500;
      color:rgba(26,61,94,1);
      cursor: pointer;
      padding-left: 50px;
      position: relative;
      box-shadow:0px 0px 0px 0px rgba(35,62,114,0.07);
      border-radius: 5px;
      .first-point-icon-question {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        justify-content: center;
        align-items: center;
        background: transparent;
        border: 1px solid rgba(26,61,94,.16);
        border-radius: 50%;
        overflow: hidden;
        width: 20px;
        height: 20px;
        img {
          width: 8px;
          height: 8px;
          transform: rotate(0deg);
          transition: all .3s;
        }
        &.is-rotate {
          background: #37CAD7;
          border: 1px solid #37CAD7;
          img {
            transform: rotate(45deg);
          }
        }
      }
      .primary-badge {
        display: inline-block;
        background:rgba(26,61,94,0.04);
        border-radius:10px;
        font-size:12px;
        line-height: 20px;
        color:rgba(26,61,94,1);
        padding: 0 8px;
        margin-left: 16px;
      }
      .new-badge {
        display: inline-block;
        background:#FACB58;
        border-radius:10px;
        font-size:12px;
        line-height: 20px;
        color: #fff;
        padding: 0 8px;
        margin-left: 16px;
      }
      &:hover {
        box-shadow:0px 2px 16px 0px rgba(35,62,114,0.07);
        .first-point-icon-question {
          border: 1px solid #37CAD7;
        }
      }
    }
    .second-point-item {
      padding-left: 40px;
      border-bottom: 1px solid #EFF4FA;
      height: 43px;
      line-height: 43px;
      background-color: #F7FBFF;
      font-size:14px;
      font-weight:400;
      color:rgba(26,61,94,1);
      cursor: pointer;
      border-radius: 5px;
      &:first-child {
        border-top: 1px solid #EFF4FA;
      }
      .sandwichIcon {
        color: #1A3D5E;
      }
      .primary-badge {
        display: inline-block;
        background:rgba(26,61,94,0.04);
        border-radius:10px;
        font-size:12px;
        line-height: 20px;
        color:rgba(26,61,94,1);
        padding: 0 8px;
        margin-left: 16px;
      }
      .new-badge {
        display: inline-block;
        background:#FACB58;
        border-radius:10px;
        font-size:12px;
        line-height: 20px;
        color: #fff;
        padding: 0 8px;
        margin-left: 16px;
      }
      &:hover {
        background-color: #EDF8FD;
      }
    }
  }
  @media screen and (max-width: 600px) {
    .question-list-item {
      .fisrt-point-box {
        .primary-badge,
        .new-badge {
          display: none;
        }
      }
    }
  }
</style>
